<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import ContentWithIcon from '@/components/common/CustomerServiceModal/ContentWithIcon.vue';
  import { formatPhoneNumber } from '@/utils/dataFormatters';

  defineOptions({ name: 'PhoneNumberWithIcon' });

  const {
    // numéro de téléphone sous la forme `[numero];[option si applicable]`
    phoneLink,
  } = defineProps<{ phoneLink: string }>();

  const formatedPhone = computed<string>(() => formatPhoneNumber(phoneLink));
  const phoneOption = computed<string>(() => phoneLink.split(';')[1] ?? '');

  const { t } = useI18n();
</script>

<template>
  <ContentWithIcon icon="phone">
    <span>
      <a :href="`tel:${phoneLink}`">
        {{ formatedPhone }}
      </a>
      <template v-if="phoneOption">
        {{ t('contactUsPage.phoneOption' , { phoneOption }) }}
      </template>
    </span>
  </ContentWithIcon>
</template>
